<div class="container-fluid">
  <div class="row justify-content-between manageaccount mt-3">
    <div class="col-xl-12">
      <div class="d-flex align-items-center justify-content-between">
        <h1 class="fs-4 fw-bold">
          Monthly Cash Expense Report : {{ monthName }} {{ year }}
        </h1>
        <button
          class="btn btn-dark btn-sm"
          mat-raised-button
          matTooltip="Back"
          matTooltipPosition="left"
          (click)="backTo()"
        >
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="contentbox mt-3">
    <div class="row customepadding">
      <div class="col-md-12 table-responsive">
        <table
          datatable
          class="row-border hover tablelist"
          *ngIf="expenseArray.length > 0"
        >
          <thead>
            <tr>
              <td>Supervisor Name</td>
              <td>Company Name</td>
              <td>Amount</td>
              <td>Expense Action</td>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let expense of expenseArray">
              <td
                [routerLink]="[
                  '../../../dateWiseExpense',
                  paramId,
                  expense.companyId,
                  expense.supervisorId,
                  this.year
                ]"
              >
                {{ expense.supervisorName }}
              </td>
              <td
                [routerLink]="[
                  '../../../dateWiseExpense',
                  paramId,
                  expense.companyId,
                  expense.supervisorId,
                  this.year
                ]"
              >
                {{ expense.companyName }}
              </td>
              <td
                [routerLink]="[
                  '../../../dateWiseExpense',
                  paramId,
                  expense.companyId,
                  expense.supervisorId,
                  this.year
                ]"
              >
                {{ expense.amount }}
              </td>
              <td
                [routerLink]="[
                  '../../../dateWiseExpense',
                  expense.month,
                  expense.companyId,
                  expense.supervisorId,
                  expense.year
                ]"
              >
                View
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
